import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { BrandmodelModel } from '../model/index';

@Injectable()
export class BrandmodelService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

        //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    });
    private brandmodelUrl = 'api/brandModel';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getBrandmodelList(query: any): Promise<BrandmodelModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.brandmodelUrl}/brandmodelList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getBrandmodel(model_id: number): Promise<BrandmodelModel> {
        const url = `${this.brandmodelUrl}/brandmodelList?model_id=${model_id}`;
        return this.http.get(url)
            .toPromise()
            .then(response => response.json().data as BrandmodelModel)
            .catch(this.handleError);
    }
 
    // getBrandItemList(): Promise<any> {
    //     const url = `${this.brandmodelUrl}/getBrandItemList`;
    //     return this.http.get(url)
    //         .toPromise()
    //         .then(this.extractData)
    //         .catch(this.handleError);
    // }

   /* getBrandItemList(): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.brandmodelUrl}/getBrandItemList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }*/
    deleteBrandmodel(model_id: any): Promise<BrandmodelModel> {
        const url = `${this.brandmodelUrl}/deleteBrandmodel`;
        return this.http
            .post(url, $.param({ model_id: model_id }), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as BrandmodelModel)
            .catch(this.handleError);
    }

    addUpdateBrandmodel(brandmodelData: any): Promise<BrandmodelModel> {

        const url = `${this.brandmodelUrl}/addUpdateBrandmodel`;

        return this.http
            .post(url, $.param(brandmodelData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as BrandmodelModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/brandmodel.service.ts